<nb-card class="card">
  <app-spinner class="spinnerFotos" *ngIf="showSpinnerFotos"></app-spinner>
  <div *ngIf="!showSpinnerFotos">
    <nb-card-header class="Header">
      <h3 class="Titulos">VIN: <span>{{infoPopup.vin}}</span> | Modelo: <span>{{infoPopup.modelo == null ? "S/N" :
          infoPopup.modelo}}</span></h3>
    </nb-card-header>
    <nb-card-body class="row card-body" style="margin-top: -30px;">

      <div class="col-6 left">
 <!-- [gestures]="false" -->
        <!-- <gallery class="appGallery" id="editar" thumbWidth=100 thumbPosition="left" [items]="items"
          [itemTemplate]="itemTemplate"> 
        </gallery> -->

        <!-- <gallery id="lightbox" thumbPosition="bottom" imageSize="cover" style="height:250px;"></gallery> -->

        <!-- GALERIA MAIN -->

              <div class="gallery-container">
                <!-- Miniaturas a la izquierda -->
                <div class="thumbnails vertical">
                  <img
                    *ngFor="let img of imageData; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen principal con contador y flechas -->
                      <div class="main-image-container">
                        <div class="counter">{{selectedIndex + 1}} / {{imageData.length}}</div>

                        <div class="main-image-with-nav" style="position: relative; display: inline-block;">
                          <button 
                            class="nav-btn prev"
                            (click)="prevImage()"
                            [disabled]="selectedIndex === 0"
                            title="Imagen anterior"
                            type="button"
                          >
                            &#10094;
                          </button>

                          <img
                            [src]="selectedImageData"
                            alt="Imagen principal"
                            (click)="openLightbox()"
                            style="display: block;"
                          >

                          <button 
                            class="nav-btn next"
                            (click)="nextImage()"
                            [disabled]="selectedIndex === imageData.length - 1"
                            title="Imagen siguiente"
                            type="button"
                          >
                            &#10095;
                          </button>
                        </div>
                      </div>


              </div>


            <!-- Lightbox -->
            <div class="lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
              <div
                class="lightbox-content with-thumbs"
                (click)="$event.stopPropagation()"
                (wheel)="onWheel($event)"
              >
                <span class="close-btn" (click)="closeLightbox()">&times;</span>

                <!-- Miniaturas izquierda en lightbox -->
                <div class="thumbnails vertical lightbox-thumbs">
                  <img
                    *ngFor="let img of imageData; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen zoomable con flechas -->
                <div class="zoom-container-with-nav">
                
                  <div class="zoom-container">
                    <div class="counter">{{selectedIndex + 1}} / {{imageData.length}}</div>
                    <img
                      [src]="selectedImageData"
                      [style.transform]="'translate(' + currentX + 'px, ' + currentY + 'px) scale(' + zoom + ')'"
                      alt="Imagen ampliada"
                      class="zoom-image"
                      (mousedown)="onMouseDown($event)"
                      (mousemove)="onMouseMove($event)"
                      (mouseup)="onMouseUp()"
                      (mouseleave)="onMouseLeave()"
                      draggable="false"
                    />
                        <button class="nav-btn prev" (click)="prevImage()">&lt;</button>
                      <button class="nav-btn next" (click)="nextImage()">&gt;</button>
                  </div>
              
                </div>
              </div>
            </div>


          <!-- END GALERIA MAIN -->





        <!-- Contador -->
        <!-- <div class="counter" *ngIf="galleryState | async as state">
          {{ state.currIndex + 1 }} / {{ state.items.length }}
        </div>
         -->
        <div class="dropdown">
          <b><span>Proceso: </span></b>
          <span class='ml-3'>{{infoPopup.proceso == null ? "S/N" : infoPopup.proceso}}</span>
        </div>

        <div *ngIf="!tipoResponsable" class="dropdown">
          <b><span>Responsable: </span></b>
          <span class='ml-3'>{{infoPopup.responsable == null ? "Sin Datos" : infoPopup.responsable}}</span>
        </div>

        <div *ngIf="tipoResponsable" class="dropdown">
          <b><span>Tipo Responsable: </span></b>
          <span class='ml-3'>{{infoPopup.tipoResponsable == null ? "Sin Datos" : infoPopup.tipoResponsable}}</span>
        </div>

        <div class="dropdown">
          <b><span>Identificador: </span></b>
          <span class='ml-3'>{{infoPopup.identificador}}</span>
        </div>

        <div class="dropdown">
          <b><span>Receptor: </span></b>
          <span class='ml-3'>{{infoPopup.receptor == null ? "S/N" : infoPopup.receptor}}</span>
        </div>

      </div>

      <div class="col-6 right">

        <div class="dropdown">
          <b><span>Area Componente: </span></b>
          <span class='ml-3'>{{infoPopup.areaComponente}}</span>
        </div>

        <div class="dropdown">
          <b><span>Zona Cuadrante: </span></b>
          <span class='ml-3'>{{infoPopup.zonaCuadranteDetalle}}</span>
        </div>

        <div class="dropdown">
          <b><span>Averia: </span></b>
          <span class='ml-3'>{{infoPopup.tipoAveria}}</span>
        </div>

        <div class="dropdown">
          <b><span>Severidad: </span></b>
          <span class='ml-3'>{{infoPopup.severidad}}</span>
        </div>

        <div class="dropdown">
          <b><span>Clasificación: </span></b>
          <span class='ml-3'>{{infoPopup.clasificacion == null ? "Sin Datos" : infoPopup.clasificacion}}</span>
        </div>

        <div class="dropdown">
          <b><span>Observación: </span></b>
          <span class='ml-3'>{{infoPopup.observacion}}</span>
        </div>

        <div class="dropdown">
          <b><span>Condición Inspección: </span></b>
          <span class='ml-3'>{{infoPopup.condicionInspeccion}}</span>
        </div>

        <div class="dropdown">
          <b><span>Condición Unidad: </span></b>
          <span class='ml-3'>{{infoPopup.condicionUnidad}}</span>
        </div>

      </div>

      <div *ngIf="!showSpinnerGuardar" class="btnsGuardar">
        <!-- <app-spinner *ngIf="showSpinnerGuardar"></app-spinner> -->
         <!-- (click)="lightbox.open(0, 'lightbox', {panelClass: 'fullscreen'})"  -->
        <button *ngIf="!showSpinnerGuardar" nbButton size="small" class="buttontz float-left"
          (click)="openLightbox()">
          <nb-icon nbPrefix icon="expand-outline"></nb-icon>
        </button>
        <button *ngIf="!showSpinnerGuardar" nbButton size="small" class="buttontz"
          (click)="closeDialog()">Cancelar</button>
      </div>

    </nb-card-body>
  </div>
</nb-card>

<ng-template #itemTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="type === 'imageViewer' && index === currIndex">
    <!-- <gallery [src]="[data.src]" [config]="myConfig"></gallery> -->
  </ng-container>
</ng-template>